<script setup lang="ts">
import { MenuButton } from '@headlessui/vue'
import type { ComponentPublicInstance } from 'vue'
import { inject, ref, watch } from 'vue'
import DTIconButton from '../DTIconButton/DTIconButton.vue'
import DTButton from '../DTButton/DTButton.vue'
import { DTDropdownProvider } from '../../keys'
import type { DropdownProvider } from '../../types/dropdown'
import type { ComplexClassName } from '../../types/common'

defineOptions({
  inheritAttrs: false,
})

withDefaults(defineProps<{
  is?: 'DTButton' | 'DTIconButton'
  wrapperClass?: ComplexClassName
}>(), {
  is: 'DTButton',
})

const dropdownProvider = inject<DropdownProvider>(DTDropdownProvider)
const trigger = ref<HTMLElement>()
const button = ref<ComponentPublicInstance>()
watch(trigger, (trigger) => {
  if (trigger)
    dropdownProvider?.registerTrigger(trigger)
})

defineExpose({ button })
</script>

<template>
  <div
    ref="trigger"
    :class="wrapperClass"
  >
    <MenuButton ref="button">
      <component
        :is="is === 'DTButton' ? DTButton : DTIconButton"
        v-bind="$attrs"
        as="div"
      >
        <slot />
      </component>
    </MenuButton>
  </div>
</template>
